/** 
 * CLIENT_INFO stores the app version number and should be filled in the app component constructor
 * Usually it is filled from the changelog content (same is done for SERVER_INFO in main)
 * ClientWebsocketService compares the appVersion between CLIENT_INFO and SERVER_INFO and shows a popup allowing user to reload page when server is updated
 */
export const CLIENT_INFO = {
    appVersion: "0.0.0"
};